export const extractWidgetJson = message => {
  const {
    content
  } = message;
  const regex = /<<({.*?})>>/;
  const match = content.match(regex);
  if (match && match[1]) {
    try {
      return JSON.parse(match[1]);
    } catch (e) {}
  }
  return null;
};
export const extractWidgetName = message => {
  var _extractWidgetJson;
  return ((_extractWidgetJson = extractWidgetJson(message)) == null ? void 0 : _extractWidgetJson.widget) ?? null;
};
//# sourceMappingURL=utils.js.map